// extracted by mini-css-extract-plugin
export var chevron = "_2j-2";
export var chevronCollapsed = "_2j-3";
export var collapsibleHeader = "_2j-1";
export var container = "_2j-0";